import React from "react";
import { Link } from "react-router-dom";

const Home: React.FC = () => {
  return (
    <div>
      {/* Hero Section */}
      <section
        className="h-[75vh] flex items-center justify-center text-white bg-cover bg-center relative"
        style={{
          backgroundImage: "url('/images/homepage/hero-bg.jpg')",
        }}
      >
        <div className="absolute inset-0 bg-black opacity-30"></div>
        <div className="text-center space-y-6 z-10">
          <h1 className="text-5xl md:text-6xl font-bold">
            DEFENDEMOS DERECHOS
          </h1>
          <h2 className="text-2xl md:text-3xl">&</h2>
          <h2 className="text-2xl md:text-3xl">PROCLAMAMOS JUSTICIA</h2>
          <p className="text-xl">Optimizamos tu acceso a la justicia</p>
          <div className="mt-8">
            <Link
              to="/contacto"
              className="px-8 py-3 rounded-full bg-black text-white hover:bg-gray-800 text-lg border-2 border-white"
            >
              CONSULTA GRATIS
            </Link>
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section className="bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex justify-center">
            <img
              src="/images/homepage/team-pic.png"
              alt="Nuestro Equipo"
              className="w-full max-w-4xl"
            />
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-16 bg-gray-100">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold mb-8">Nuestros Servicios</h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-white p-8 shadow-md">
              <h3 className="text-xl font-bold mb-4">Asuntos legales</h3>
              <div className="flex justify-center mb-6">
                <img
                  src="/images/homepage/asuntos-legales.png"
                  alt="Asuntos Legales"
                  className="max-w-full h-auto"
                />
              </div>
            </div>

            <div className="bg-white p-8 shadow-md">
              <h3 className="text-xl font-bold mb-4">Consultoría</h3>
              <ul className="space-y-4 mt-8">
                <li className="border-b pb-2">Minutas</li>
                <li className="border-b pb-2">Logos</li>
                <li className="border-b pb-2">Crear Empresa</li>
              </ul>
              <div className="mt-8">
                <Link
                  to="/contacto"
                  className="px-6 py-3 bg-black text-white rounded-full hover:bg-gray-800 inline-block"
                >
                  Haz una Reserva
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Allies Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold">NUESTROS ALIADOS</h2>
            <p className="text-gray-600 mt-4">coming soon...</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
